import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react'
import { Link } from 'react-router-dom'

export type BreadcrumbItem = { label: string; to?: string }

type Ctx = {
  items: BreadcrumbItem[]
  setItems: (items: BreadcrumbItem[]) => void
}

const BreadcrumbsContext = createContext<Ctx | undefined>(undefined)

export function BreadcrumbsProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<BreadcrumbItem[]>([])
  const value = useMemo(() => ({ items, setItems }), [items])
  return (
    <BreadcrumbsContext.Provider value={value}>{children}</BreadcrumbsContext.Provider>
  )
}

export function useBreadcrumbs() {
  const ctx = useContext(BreadcrumbsContext)
  if (!ctx) throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider')
  return ctx
}

export function BreadcrumbsBar() {
  const ctx = useContext(BreadcrumbsContext)
  if (!ctx || ctx.items.length === 0) return null
  const { items } = ctx
  return (
    <nav className="hidden md:flex h-8 items-center text-xs text-gray-600 dark:text-gray-300">
      {items.map((it, idx) => (
        <React.Fragment key={idx}>
          {it.to ? (
            <Link to={it.to} className="hover:underline">
              {it.label}
            </Link>
          ) : (
            <span className="font-medium text-gray-800 dark:text-gray-100">{it.label}</span>
          )}
          {idx < items.length - 1 && <span className="mx-2 text-gray-400">/</span>}
        </React.Fragment>
      ))}
    </nav>
  )
}
